module.exports = __webpack_public_path__ + "img/e44.4b5402bf.png";